<template>
  <div class="search">
    <nav class="search-nav">
        <div class="search-nav-wrap">
            <input type="text" name="" v-model="schVal" placeholder="请输入股票名称/代码">
        </div>
    </nav>
    <div class="search-content">
      <div class="search-mod" v-if="searchList.length>0">
        <h5>股票</h5>
        <ul>
          <li v-for="(item,index) in searchList" :key="index" @click="jump(item)">
            <span>{{item.MingCheng}}</span><span>{{item.DaiMa}}</span>
          </li>
        </ul>
      </div>
      <div class="search-blank" v-else>暂无您搜索的数据</div>
      <div class="search-mod">
        <h5>历史搜索 <span class="btn-clear" @click="clear()">清除历史记录</span></h5>
        <div class="search-history" v-if="resList_his.length>0">
          <span v-for="(item,index) in resList_his" :key="index" @click="jump1(item)">{{item.MingCheng}}</span>
        </div>
        <div class="search-blank" v-else>暂无历史数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import {share} from '@/lib/dzh'
import wxshare from '@/assets/js/wxshare'

export default {
  name: 'searchPage',
  data () {
    return{
      schVal:'',
      searchList:[],
      resList_his:[],
      cardName:''
    }
  },
  watch:{
    schVal(curVal){
      var ts = this;
      axios.get(window.JIANPANBAO, {
          params: {
              q:curVal
          }
      }).then(response => {
          ts.getList(response.data.Data.Docs);
      })
    }
  },
  created(){
        wxshare.do(this.$route.fullPath,'http://static.yundzh.com/logo.png','沪深港通');
    },
  mounted:function(){
    this.historySearch();
     document.title = '沪深港通';
        share("沪深港通",this.$route.fullPath);
  },
  methods:{
    historySearch() {
      if (localStorage.getItem("search_history") != null) {
        this.resList_his = JSON.parse(localStorage.search_history);
      }
    },
    clear(){
      this.resList_his = [];
      localStorage.removeItem("search_history");
    },
    getList (data) {
      let _resStockList = [];
      let _res = [];
      _resStockList = data;
      _resStockList.forEach((eachObj)=>{
          eachObj.MingCheng = eachObj.Name;
          eachObj.DaiMa = eachObj.Market + eachObj.Code;
           _res.push(eachObj);
      });
      this.searchList = _res;
    },
    jump(stock){
      if (localStorage.getItem("search_history") != null) {
        let list = JSON.parse(localStorage.search_history);
        let flag = false;
        list.forEach((eachObj)=>{
          if (eachObj.Code == stock.Code) {   //已经存在
            flag = true;
          }
        })
        if (!flag) {
          if (list.length>10) {
            list.pop();
          }
          list.unshift(stock);
          localStorage.search_history = JSON.stringify(list);
        }
      } else {
        let list = [];
        list.push(stock);
        localStorage.search_history = JSON.stringify(list);
      }
      location.href = window.location.protocol+"//"+window.location.host + window.location.pathname + "#/ss/"+stock.DaiMa +"/" +stock.MingCheng+"?DZHSPECIAL=265";
    },
    jump1(stock){
      location.href = window.location.protocol+"//"+window.location.host + window.location.pathname + "#/ss/"+stock.DaiMa +"/" +stock.MingCheng+"?DZHSPECIAL=265";
    },
  }
}
</script>
